export const progressStatus = {
    new: "new",
    setPrize: "set_prize",
    setTemplate: "set_template",
    published: "published"
  };
  